import './frontend/frontend.scss';

function initSlider() {
	document.querySelectorAll('.wp-block-da-slider .splide').forEach(sliderEl => {
		new Splide(sliderEl).mount();
	});
}

if (document.readyState != 'loading') {
	initSlider();
} else {
	document.addEventListener('DOMContentLoaded', initSlider);
}